import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import themePrimary from '../../styles/themePrimary';
import { makeStyles } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { String_System_ErrorDialogTitle, String_System_Ok, String_System_TryAgain } from '../../utilities/StringHelper';

const useStyles = makeStyles({
    errorIcon: {
        color: themePrimary.palette.error.main,
        fontSize: '1.5em',
        marginRight: '10px',
        marginBottom: '2px',
    },
    text: {
        fontFamily: 'LeagueSpartan-Regular !important',
    },
});

export type MessageDialogCloseClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface MessageDialogProps {
    message: string;
    open: boolean;
    onCloseHandler: MessageDialogCloseClickHandler;
}

export default function MessageDialog(props: MessageDialogProps) {
    const { message, open, onCloseHandler } = props;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        onCloseHandler(event);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" className={classes.text}>
                    Demo System
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.text}>
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        {String_System_Ok.find(s => s.key === userState.state.locale)!!.value}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}